import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { env } from '../../configs/EnvironmentConfig'
import { AUTH_TOKEN } from 'constants/AuthConstant';

export const initialState = {
    users: null,
    anonymousUsers: null,
    loading: false,
    message: '',
    isError: false
}

const path = (baseUrl, endpoint) => {
    return `${baseUrl}/user-service/v1/${endpoint}`;
};

export const getUsers = createAsyncThunk('/users', async () => {
    const url = path(env.USER_SERVICE, 'users');
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'authorization': localStorage.getItem(AUTH_TOKEN)
        }
    })
    return response.json();
});

export const getAnonymousUsers = createAsyncThunk('/anonymous-users', async () => {
    const url = path(env.USER_SERVICE, 'anonymous-users');
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'authorization': localStorage.getItem(AUTH_TOKEN)
        }
    })
    return response.json();
});

export const userServiceSlice = createSlice({
    name: 'userService',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
           .addCase(getUsers.pending, (state)=> {
                state.loading = true
                state.isError = false
                state.users = []
                state.message = 'Request sent'
            })
           .addCase(getUsers.rejected, (state) => {
                state.loading = false
                state.isError = true
                state.users = []
                state.message = 'Request failed'
            })
           .addCase(getUsers.fulfilled, (state, action) => {
                state.loading = false
                state.isError = false
                state.users = action.payload.users
                state.message = 'Request successful'
            })
           .addCase(getAnonymousUsers.pending, (state)=> {
                state.loading = true
                state.isError = false
                state.anonymousUsers = []
                state.message = 'Request sent'
            })
           .addCase(getAnonymousUsers.rejected, (state) => {
                state.loading = false
                state.isError = true
                state.anonymousUsers = []
                state.message = 'Request failed'
            })
           .addCase(getAnonymousUsers.fulfilled, (state, action) => {
                state.loading = false
                state.isError = false
                state.anonymousUsers = action.payload.anonymousUsers
                state.message = 'Request successful'
            })
    }
});

export default userServiceSlice.reducer
